<template>
  <footer class="c-footer o-typography__body2 u-desktop-only">
    <div class="c-footer__triangle"></div>
    <div class="c-footer__row u-color-primary">
      <div
        v-for="item in footerItems"
        class="c-footer__column"
      >
        <h4 class="c-footer__header">
          {{ item.name }}
        </h4>
        <h5 v-for="element in item.elements">
          <v-link
            v-if="element.url"
            :key="element.name"
            :to="element.url"
            class="o-typography--action"
            :target="element.target || '_self'"
          >
            {{ element.name }}
          </v-link>
        </h5>
      </div>
    </div>
    <p class="c-footer__copyright u-color-secondary">
      {{ $t('application.copyright', { year: currentYear }) }}
    </p>
  </footer>
</template>
<script>
  import dayjs from 'dayjs';
  import { VLink } from '@/index/shared/components';

  export default {
    components: {
      VLink,
    },
    data() {
      return {
        footer: this.$services.resolve('footer'),
        subscriber: this.$services.resolve('subscriber'),
        currentYear: dayjs().year(),
      };
    },
    computed: {
      footerItems() {
        if (this.subscriber.isKidsTheme) {
          return this.footer.data.desktopKids;
        }

        return this.footer.data.desktop;
      },
    },
  };
</script>
